import AlwaysOn from '../img/icon-always-on.svg';
import Cooking from '../img/icon-cooking.svg';
import Entertainment from '../img/icon-entertainment.svg';
import Laundry from '../img/icon-laundry.svg';
import Lighting from '../img/icon-lighting.svg';
import Other from '../img/icon-other.svg';
import PoolPump from '../img/icon-pool-pump.svg';
import Refrigeration from '../img/icon-refrigeration.svg';
import WholeHome from '../img/icon-whole-home.svg';
import WaterHeating from '../img/icon-water-heating.svg';
import Cooling from '../img/icon-cooling.svg';
import ElectricVehicle from '../img/icon-ev.svg';
import Heating from '../img/icon-heating.svg';
import { INSIGHTS_PATH } from './paths';

export const APPLIANCES_ID_TO_DETAILS = {
  4 : {name : "Air Conditioning", iconClassName : 'ac'},
  3 : {name : "Space Heating", iconClassName : 'heating'},
  8 : {name : "Always On", iconClassName : 'always-on'},
  2 : {name : "Pool", iconClassName : 'pool-pump'},
  59: {name : "Laundry & Cleaning", iconClassName : 'laundry'},
  66: {name : "Entertainment", iconClassName : 'entertainment'},
  71: {name : "Lighting", iconClassName : 'lighting'},
  9 : {name : "Refrigeration", iconClassName : 'refrigerator'},
  7 : {name : "Water Heating", iconClassName : 'water-heater'},
  18: {name : "Electric Vehicle", iconClassName : 'ev'},
  5 : {name : "Cooking", iconClassName : 'cooking'},
  99: {name : "Other", iconClassName : 'other-electric'}
};

export const RECO_APPLIANCE_LIST_ICONS = {
  0: WholeHome,
  8: AlwaysOn,
  2: PoolPump,
  59: Laundry,
  66: Entertainment,
  71: Lighting,
  9: Refrigeration,
  7: WaterHeating,
  18: ElectricVehicle,
  4: Cooling,
  3: Heating,
  5: Cooking,
  99: Other
};

export const SELECT_ALL = 'SELECT_ALL';
export const WHOLE_HOME = 'WHOLE_HOME';
export const WHOLE_HOME_ICON = WholeHome;
export const HOME_SURVEY = 'Home Survey';
export const TOTAL_APP_ID = "17";

export const EFFORT_LIST = ["Easy", "Medium", "Hard"];
export const COST_LIST = [1, 2, 3, 4, 5];
export const FUEL_UNITS = {
  "kWh": "kWh",
  "CCF": "CCF"
};

export const INSIGHTS_USAGE_COLORS = {
  "8": "--color_62",
  "4": "--color_85",
  "59": "--color_67",
  "18": "--color_72",
  "7": "--color_61",
  "2": "--color_73",
  "5": "--color_64",
  "9": "--color_63",
  "66": "--color_66",
  "3": "--color_60",
  "71": "--color_68",
  "99": "--color_70"
};

export const TOOLTIP_COMPONENT_NAME = {
  APP_BAR: "APP_BAR",
  FOOTER: "FOOTER"
}

export const WIDGETS = {
  APP_BAR: "NAVBAR",
  HOME: {
    WEATHER : "WEATHER",
    CONSUMPTION_BREAKDOWN : "CONSUMPTION_BREAKDOWN",
    USAGE_SUMMARY : "USAGE_SUMMARY",
    USAGE_HISTORY : "USAGE_HISTORY",
    INSIGHTS_FEED : "INSIGHTS_FEED",
    SMART_RECO : "SMART_RECOMMENDATION",
    ENVIRONMENT : "ENVIRONMENT",
    BILL_PROJECTION: "BILL_PROJECTION",
    ACTIVITY_MAP: "ACTIVITY_MAP"
  },
  INSIGHTS: {
    USAGE: "INSIGHTS.USAGE",
    MONTHLY_SUMMARY: "INSIGHTS.MONTHLY_SUMMARY",
    BILL_ANALYSIS: "INSIGHTS.BILL_ANALYSIS",
    SHC: "INSIGHTS.SIMILAR_HOMES_COMPARISON",
    ACTIVITY_MAP: "INSIGHTS.ACTIVITY_MAP",
    RATE_PLANS: "INSIGHTS.RATE_PLANS"
  },
  SURVEY: "SURVEY",
  RECOMMENDATIONS: "RECOMMENDATIONS",
  MARKETPLACE: "MARKETPLACE",
  SETTINGS_AND_PREFERENCES: "SETTINGS_AND_PREFERENCES",
  FOOTER: "FOOTER",
  FEEDBACK: "FEEDBACK"
};

export const GLOBAL_EVENTS = {
  FETCH_LANGUAGE_PREFERENCES: "FETCH_LANGUAGE_PREFERENCES",
  FETCH_USER_TYPE: "FETCH_USER_TYPE",
  FETCH_CONSUMPTION_DATA_SUMMARY: "FETCH_CONSUMPTION_DATA_SUMMARY"
};

export const LAUNCHPAD_TOOLTIP_ELEMENTS = [
  {key:"bg-color", label:"Background Color"},
  {key:"text-color",label:"Text Color"},
  {key:"graph-bar-color",label:"Graph Bar Color"},
  {key:"graph-label-color",label:"Graph Label Color"},
  {key:"show-appliances-colors",label:"Graph Appliance Colors"},
  {key:"hover-color",label:"Hover Color"},
  {key:"hover-text-color",label:"Hover Text Color"},
  {key:"disabled-bg-color",label:"Disabled Background Color"},
  {key:"disabled-text-color",label:"Disabled Text Color"},
  {key:"nav-bg-color",label:"Nav Bg Color"},
  {key:"nav-arrow-color",label:"Nav Arrow Color"},
  {key:"border-color",label:"Border Color"},
  {key:"icon-color",label:"Icon Color"},
  {key:"link-color",label:"Link Color"},
  {key:"active-color",label:"Active Text Color"},
  {key:"active-bg-color",label:"Active Background Color"}];

export const BAR_COLOR = '--color_17';
export const BAR_HOVER_COLOR = '--color_39';
export const NA = {
  NAME: "NA",
  COLOR: "--color_37"
};
export const ONGOING = {
  NAME: "Ongoing",
  COLOR: "--color_38"
};
export const TEMPERATURE = {
  NAME: "Temperature",
  COLOR: "--color_71",
  FILL_COLOR: "--color_7",
  GRAPH_TYPE: "spline",
  COLOR_V2 : "--color_19"
};

export const USAGE_COLORS = {
  ITEMIZATION_LEGEND_COLOR: "--color_2",
  ITEMIZATION_WEEKEND_COLOR: '--color_12',
  TOOLTIP_BACKGROUND_COLOR: "--color_7",
  TOOLTIP_BACKGROUND_COLOR_V2 : "--color_54"
};

export const DEFAULT_FONT_FAMILY = "Montserrat";

export const DEFAULT_FONT_CONFIG = {
  google: {
    families: ["Montserrat:200,300,400,500,600,700,800"]
  }
}

export const FONT_WEIGHT = {
  light: 100,
  semiLight : 300,
  normal: 400,
  medium: 500,
  bold: 600
};

export const CHANNEL_TYPES = {
  EMAIL: "email",
  SMS: "sms",
  WEB: "web"
};

export const BUDGET_THRESHOLD_AMOUNT = "BUDGET_THRESHOLD_AMOUNT";
export const BUDGET_ALERT = "BUDGET_ALERT";

export const TIMESCALE = {
  YEAR: "Year",
  MONTH: "Month",
  DAY: "Day"
};
export const NA_FALLBACK_TEXT = "N/A";

export const USER_SEGMENT = {
  SMB: "SMB",
  RESIDENTIAL: "RESIDENTIAL"
};

export const FUEL_TYPE = {
  GAS: 'gas',
  ELECTRIC: 'electric'
};
export const USAGE_TYPE = {
  COST: 'cost',
  ENERGY: 'energy',
  USAGE: 'usage',
  PERCENTAGE : 'percentage'
};

export const LIKE = 'Like';

export const GRAPH_STYLE = {
  COLUMN: "column",
  AREA: "area"
};

export const TOTAL = 'Total';
export const WEATHER = 'Weather';

export const SURVEY_STATUS = {
  PENDING: "PENDING",
  SUCCESS: "SUCCESS",
  FAILURE: "FAILURE",
  TIMEOUT: "TIMEOUT"
};

export const USAGE_DASHBOARD_YEAR_ITEMS_TO_SHOW = 13;

export const USAGE_CHART_EVENTS = {
  CHANGE_MODE: "changeMode",
  TOGGLE_GAS_ELECTRIC: "toggleGasElectric",
  CHANGE_MONTH_OFFSET: "changeMonthOffset",
  CHANGE_DAY_OFFSET: "changeDayOffset",
  SET_HIGHCHARTS_DATA: "setHighchartsData",
  CHANGE_YEAR_OFFSET: "changeYearOffset",
  FETCH_MONTH_FROM_YEAR: "fetchMonthFromYear",
  FETCH_DATE_FROM_MONTH: "fetchDateFromMonth",
  SHOW_DATA_NOT_AVAILABLE: "showDataNotAvailable",
  CLEAR_DATA_NOT_AVAILABLE_DISCLAIMER: "clearDataNotAvailableDisclaimer",
  SAVE_YEAR_DATA: "saveYearData",
  SAVE_MONTH_DATA: "saveMonthData",
  SAVE_DAY_DATA: "saveDayData",
  SAVE_BILLING_CYCLE_INFO: "saveBillingCycleInfo",
  SHOW_DATA_EMPTY: "showDataEmpty",
  CHANGE_GRAPH_STYLE: "changeGraphStyle",
  TOGGLE_DROPDOWN: "toggleDropdown",
  TOGGLE_COST_ENERGY: "toggleCostEnergy",
  TOGGLE_WEATHER: "toggleWeather",
  UPDATE_HIGHCHARTS_OBJECT: "updateHighChartsObject",
  CHECK_ARROW_DISABLED: "checkArrowDisabled",
  SET_PROPS_FOR_COST_OR_CONSUMPTION: "setPropsForCostOrCosnumptionMode",
  UPDATE_SELECTED_APPLIANCE : "updateSelectedAppliance"
};

export const USAGE_SHC_EVENTS = {
  CHANGE_YEAR_OFFSET: 'changeYearOffset',
  UPDATE_HIGHCHARTS_OBJECT: 'updateHighchartsObject',
  SET_SHC_DATA: 'setSHCData',
  SAVE_BC_DATA: 'saveBCData',
  SAVE_SHC_CHART_DATA_PAYLOAD: 'saveSHCChartDataPayload',
  CHANGE_SELECTED_APPLIANCE: 'changeSelectedAppliance',
  SET_DATA_NOT_AVAILABLE: 'setDataNotAvailable',
  SET_ARROW_DISABLED: 'setArrowDisabled',
  SET_HIGHCHARTS_DATA: 'setHighchartsData',
  SAVE_BILLING_CYCLE_INFO: 'saveBillingCycleInfo',
  SAVE_APPLIANCE_NAVBAR_LIST: 'saveApplianceNavbarList',
  SAVE_CHART_API_PAYLOAD: 'saveChartApiPayload',
  SIMILAR_HOMES_API_ERROR: 'similarHomesApiError'
};

export const PREFERENCE = {
  TABS: {
    CONTACT_INFO: "CONTACT_INFO",
    ALERT_TYPE: "ALERT_TYPE",
    ALERT_TYPE_ELECTRIC: "ALERT_TYPE_ELECTRIC",
    ALERT_TYPE_GAS: "ALERT_TYPE_GAS",
    SETTINGS: "SETTINGS"
  },
  URLS: {
    CONTACT_INFO: "contact-info",
    ALERT_TYPE: "alert-type",
    ALERT_TYPE_ELECTRIC: "alert-type/electric",
    ALERT_TYPE_GAS: "alert-type/gas",
    SETTINGS: "settings"
  },
  EDIT: "edit",
  SAVE_CHANGES: "Save Changes"
};

export const SCREEN_BREAKPOINTS = {
  LARGE_DESKTOP: "1200",
  DESKTOP: "992",
  TABLETS: "768",
  MOBILE: "576"
};

export const HOME = "HOME";

export const ALLOWED_QUERY_PARAMS =  ['event-type','tab-type','ref-type','feedback-type', 'event-type', 'locale',
'delivery-mode', 'reco-id', 'question-id', 'widget-name', 'hide-page-title', 'widget-id', 'app-id', 'bill-start',
'compare-bill-start', 'measurement-type', 'season-type', 'file-name', 'her-modules-order', 'usage-mode', 'usage-view', 'fuel-type'];

export const HOME_INSIGHTS_DATA_FEEDTYPE = ['INTERESTING_INSIGHTS', 'ENERGY_SAVING_RECO'];

export const PIE_CHART_SIZE = {
  LARGE : {
    outerSlice : {
      size : '260px',
      innerSize : '243px'
    },
    innerRing : {
      size : '250px',
      innerSize : '210px'
    },
    innerSlice : {
      size : '250px',
      innerSize : '210px'
    }
  },
  MEDIUM : {
    outerSlice : {
      size : '210px',
      innerSize : '190px'
    },
    innerRing : {
      size : '200px',
      innerSize : '160px'
    },
    innerSlice : {
      size : '200px',
      innerSize : '190px'
    }
  },
  SMALL : {
    outerSlice : {
      size : '150px',
      innerSize : '143px'
    },
    innerRing : {
      size : '143px',
      innerSize : '115px'
    },
    innerSlice : {
      size : '150px',
      innerSize : '107px'
    }
  }
};

export const PAGE_EVENT_NAMES = {
  FAQ: "web.disagg101",
  FEEDBACK: "email.feedback",
  INSIGHTS: "web.app.dashboardv3Insight",
  RECOMMENDATIONS: "web.app.tips",
  DASHBOARD: "web.app.dashboardv3",
  PREFERENCE: "web.app.preferences",
  SURVEY: "web.homeAssessmentSurvey",
  MARKETPLACE : "web.marketplace",
  DECARBONIZATION: "web.decarbonization"
};

export const EVENT_NAMES = {
  USAGE_COST_TOGGLE: 'usageCostToggle',
  WEATHER_TOGGLE: 'weatherToggle',
  FUEL_TOGGLE: 'fuelToggle',
};

export const ARROWS = {
  LEFT: "arrow-left",
  RIGHT: "arrow-right"
};

export const INSIGHTS_PAGES = {
  USAGE: 'USAGE',
  MONTHLY_SUMMARY: 'MONTHLY SUMMARY',
  SIMILAR_HOMES: 'SIMILAR HOMES',
  BILL_ANALYSIS: 'BILL ANALYSIS'
};

export const DASHBOARD = {
  READ_MORE_INSIGHT: 'readMoreInsight',
  HOME_ASSESSMENT_SURVEY: 'homeAssessmentSurvey'
}


export const SHC_BC = 'SHC_BC';

export const NONE = 'None';

export const RECO_TYPE = {
  CAROUSEL: "carousel",
  PROGRAM : "program",
  GRID: "grid"
};

export const SURVEY_QUESTION_TYPES = {
  SINGLE: "SINGLE",
  MULTIPLE: "MULTIPLE",
  NUMBER: "NUMBER",
  MULTIPLE_WITH_SUB_CHOICES: "MULTIPLE_WITH_SUB_CHOICES"
};

export const SSO_DESTINATION = {
  DASHBOARD: "dashboard",
  PREFERENCES: "userPreferences",
  SURVEY: "homeProfile"
};

export const SURVEY_QUESTION_STATE = {
  ANSWERED: "ANSWERED",
  UNANSWERED: "UNANSWERED"
};

export const RECO_RESPONSE = {
  LIKE : "Like",
  DISLIKE : "dislike",
  UNLIKE : null
}

export const SLICK_ITEMS_TO_SHOW = {
  DESKTOP : 3,
  TABLETS : 2,
  MOBILE : 1
}

export const MAX_BC_TO_SHOW = 13;

export const PRODUCT_TYPE_CONFIG = {
  WEB: 'frontend_configs',
  HER: 'her_frontend_configs'
};

export const TAG_TYPE = {
  WEB: 'ui',
  HER: 'her_ui'
};

export const COLOR_PALETTE_TYPE = {
  WEB: 'default_palette_ui',
  HER: 'her_palette_ui'
};

export const PRODUCT_TYPE = {
  WEB: 'WEB',
  HER: 'HER'
};

export const LEARN_MORE = "Learn More"

export const COMPARED_TO_TYPE_VS_ICON = {
  NO_OF_HOMES: 'bidgely-icon-home',
  DWELLING_TYPE: 'bidgely-icon-home-type',
  ZIP_CODE: 'bidgely-icon-location',
  HOME_HEATING_TYPE: 'bidgely-icon-heating-type',
  HOME_SIZE: 'bidgely-icon-home-size'
};

export const FONT_STATUS = {
  LOADING: 'loading',
  ACTIVE: 'active'
};

export const WIDGET_LAYOUT = {
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal'
};

export const HER_MODULE_EVENT = {
  MODULE_LOADED: 'MODULE_LOADED',
  MODULES_TO_BE_LOADED: 'MODULES_TO_BE_LOADED'
};

export const HER_MODULES = {
  HEADER: 'HEADER',
  APPLIANCE_SHC_GRAPH_AND_WIDGET: 'APPLIANCE_SHC_GRAPH_AND_WIDGET',
  SHC_EFFICIENT: 'SHC_EFFICIENT',
  USAGE_SUMMARY: 'USAGE_SUMMARY',
  SPONSORED_RECO: 'SPONSORED_RECO',
  PERSONALIZED_TIPS: 'PERSONALIZED_TIPS',
  HVAC_INSIGHTS: 'HVAC_INSIGHTS',
  FAQ: 'FAQ',
  FOOTER: 'FOOTER'
};

export const DEFAULT_HER_MODULES_ORDER = [HER_MODULES.HEADER, HER_MODULES.APPLIANCE_SHC_GRAPH_AND_WIDGET, HER_MODULES.USAGE_SUMMARY, HER_MODULES.SPONSORED_RECO, HER_MODULES.PERSONALIZED_TIPS, HER_MODULES.FAQ, HER_MODULES.FOOTER];

export const FEEDBACK_QUESTION_TYPE = {
  FREE_RESPONSE: "FREE_RESPONSE",
  MULTIPLE_CHOICE: "MULTIPLE_CHOICE"
}

export const USER_TYPE = {
  AMI: "GB",
  NSM: "GB_MONTH"
};

export const INSIGHT_USAGE_VERSIONS = {
  V1 : "V1",
  V2 : "V2"
}

export const INSIGHT_USAGE_V2_VIEWS = {
  APPLIANCE : 'APPLIANCE',
  COST : 'COST',
  USAGE : 'USAGE'
}

export const TIME_OF_USE = {
  ALL :{
    type: 'ALL'
  },
  OFF_PEAK : {
    type : 'OFF_PEAK',
    name : 'Off Peak',
    itemizationKey : "OffPeak",
    color : '--color_79'
  },
  MID_PEAK : {
    type : 'MID_PEAK',
    name : 'Mid Peak',
    itemizationKey : 'MidPeak',
    color : '--color_80'
  } ,
  ON_PEAK : {
    type : 'ON_PEAK',
    name : 'On Peak',
    itemizationKey : 'Peak',
    color : '--color_81'
  }
}

export const TIER = {
  0 : {
    color : '--color_82'
  },
  1 : {
    color : '--color_83'
  },
  2 : {
    color : '--color_84'
  }
}

export const SECONDS_IN_DAY = 86400;

export const ALLOWED_IN_MEMORY_CONFIGS = ["supported_languages", "default_locale", "supported_locale", "language_to_locale"];

export const ALLOWED_IN_MEMORY_TRANSLATIONS = ["DASHBOARD.CURRENCY_STRING", "APPLIANCES"];

export const SURVEY_CHOICES_SELECTION_TYPE = {
  LIST: "LIST"
};

export const SURVEY_SUBCHOICE_VALIDATION_TYPE = {
  ASC_ALLOWED_VALUES: "ASC_ALLOWED_VALUES"
};

export const INSIGHT_USAGE_CHART_DISCLAIMERS = {
  ONGOING_BILLING_CYCLE : { name: 'ONGOING_BILLING_CYCLE', id : "USAGE.DISCLAIMER.ONGOING_BILLING_CYCLE", icon: "DISCLAIMER_ICONS.USAGE.ICON1"},
  INCLUDE_ONLY_USAGE : {name : 'INCLUDE_ONLY_USAGE', id : "INCLUDE_ONLY_USAGE", icon: ""},
  ITEMIZATION_UNAVAILABLE : {name : 'ITEMIZATION_UNAVAILABLE', id : "USAGE.DISCLAIMER.ITEMIZATION_UNAVAILABLE", icon: "DISCLAIMER_ICONS.USAGE.ICON2"},
  MISSING_DATA : {name : 'MISSING_DATA', id: "USAGE.DISCLAIMER.BILL_UNAVAILABLE", icon: "DISCLAIMER_ICONS.USAGE.ICON3"},
  NSM_CYCLE : {name : 'NSM_CYCLE', id: "USAGE.DISCLAIMER.NSM_CYCLE", icon: ""}
}

export const INSIGHT_USAGE_CHARTS = {
  USAGE : "USAGE",
  DEMAND_CHARGE : "DEMAND_CHARGE"
}

export const DEMAND_CHARGE = {
  COLOR: "--color_71",
  FILL_COLOR: "--color_71",
  GRAPH_TYPE: "spline"
};

export const POWER_UNIT = 'kW';

export const RATE_PLAN  = {
  POSITIVE : "POSITIVE",
  NEGATIVE : "NEGATIVE"
};

export const ACTIVITY_MAP_VIEWS = {
  HOURS_OF_OPERATION: "HOURS_OF_OPERATION",
  TIME_OF_USE: "TIME_OF_USE",
  EVENTS: "EVENTS"
};

export const FEEDBACK_TYPE = {
  NEUTRAL : 'NEUTRAL'
}

export const UNSUPPORTED_PAGES = {
  ELECTRIC : {
    "GB" : [],
    "GB.MONTH" : [INSIGHTS_PATH.BILL_ANALYSIS]
  },
  GAS : {
    "GB" : [],
    "GB_MONTH" : [INSIGHTS_PATH.BILL_ANALYSIS]
  }
}